import React, { useState } from "react";
import { AppLayout } from "../../layouts";
import { Cards, Header, NavAndTabs, Sides } from "../../components";
import { Col, Container, Image, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionAdmin, actionPatient } from "../../redux/actions";
import { PiCalendar, PiFolderUserThin, PiPhoneLight } from "react-icons/pi";
import { AiOutlineMail } from "react-icons/ai";
import { Commons } from "../../utilities";
import HealthInformation from "./healthInformation";
import HealthMonitoring from "./healthMonitoring";
import AppointmentHistory from "./appointmentHistory";
import { useTranslation } from "react-i18next";

const PatientDetailsPage = ({ loginData }) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState(id || "health-information");

    const patient = location.state?.patient;

    useEffect(() => {
        if (patient?.patientGuid && loginData?.languageId) {
            dispatch(
                actionAdmin.getPatientViewDetails(
                    patient.patientGuid,
                    loginData?.languageId
                )
            );
        }
    }, [patient?.patientGuid, loginData?.languageId, dispatch]);

    useEffect(() => {
        dispatch(actionPatient.getQuestion(1, loginData?.languageAbb));
    }, [dispatch, loginData?.languageAbb]);

    useEffect(() => {
        dispatch(actionPatient.getAnswers(patient?.patientGuid, 1));
    }, [dispatch, patient?.patientGuid]);

    useEffect(() => {
        dispatch(
            actionPatient.getAppointments(
                10,
                1,
                "",
                "",
                "",
                patient?.patientGuid,
                "",
                4,
                "",
                "",
                null,
                null,
                loginData?.currencyCode,
                loginData?.timeZoneId,
                null,
                null,
                null,
                loginData?.languageId,
                [1, 2, 3],
                true
            )
        );
    }, [dispatch, loginData?.currencyCode, loginData?.languageId, loginData?.timeZoneId, patient?.patientGuid]);

    const getPatientViewDetailsData = useSelector(
        (state) => state.admin.getPatientViewDetailsData?.data
    );
    const getAppointmentsData = useSelector(
        (state) => state.patient.getAppointmentsData?.data
    );


    const onTabChange = (tabId) => {
        setActiveTab(tabId);
        navigate(
            `/doctor/patient-details/${tabId}`,
            { state: { patient: patient } }
        );
    };

    const tabs = [
        {
            id: "health-information",
            label: t("patient_Details.health_information.health_information"),
            content: <HealthInformation />,
            disabled: false,
        },
        {
            id: "health-monitoring",
            label: t("patient_Details.health_monitoring.health_monitoring"),
            content: <HealthMonitoring />,
            disabled: false,
        },
        {
            id: "appointment-history",
            label: t("patient_Details.appointment_history.appointment_history"),
            content: <AppointmentHistory loginData={loginData} />,
            disabled: false,
        },
    ];

    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage
                        pageHeading={`My Patients / ${patient.firstName} ${patient.lastName}`}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col xs="auto">
                    <div className="profile-img-blk">
                        <Image
                            src={getPatientViewDetailsData?.result?.profileImage}
                            className="profile-img"
                        />
                    </div>
                </Col>
                <Col xs="auto" className="pt-name-col">
                    <h3>
                        {patient.firstName} {patient.lastName}
                    </h3>
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <Cards.Cardd
                        header={
                            <>
                                <div className="blkIcon">
                                    <PiFolderUserThin className="iicon" />
                                </div>
                                <h5 className="exado-title-seven card-header-text">
                                    {t("patient_information")}
                                </h5>
                            </>
                        }
                        content={
                            <ul className="card-pd-ul">
                                <li className="card-pd-list exado-title-six">
                                    {t("Insurance_Nr")}. :{" "}
                                    {getPatientViewDetailsData?.result?.socialSecurityNumber}
                                </li>
                                <li className="card-pd-list exado_body_text_three">
                                    {t("patient_details")}{" "}
                                </li>
                                <li className="card-pd-list exado-title-six">
                                    {getPatientViewDetailsData?.result?.firstName}{" "}
                                    {getPatientViewDetailsData?.result?.lastName}
                                </li>
                                <li className="card-pd-list exado-title-six">
                                    {t("age")} :{" "}
                                    {Commons.calculateAge(getPatientViewDetailsData?.result?.doB)}
                                </li>
                                <li className="card-pd-list exado-title-six">
                                    {t("Gender")} :
                                    {getPatientViewDetailsData?.result?.gender == 1
                                        ? t("Male")
                                        : getPatientViewDetailsData?.result?.gender == 2
                                            ? t("Female")
                                            : t("Other")}
                                </li>
                                <li className="card-pd-list exado-title-six">
                                    {t("weight")} : {getPatientViewDetailsData?.result?.weight} lbs
                                </li>
                                <li className="card-pd-list exado-title-six">
                                    {t("height")} : {getPatientViewDetailsData?.result?.height} cm
                                </li>
                            </ul>
                        }
                        className="cardd cardd1"
                    />
                </Col>
                <Col>
                    <Cards.Cardd
                        header={
                            <>
                                <div className="blkIcon">
                                    <PiFolderUserThin className="iicon" />
                                </div>
                                <h5 className="exado-title-seven card-header-text">
                                    {t("patient_Details.contact_information")}
                                </h5>
                            </>
                        }
                        content={
                            <ul className="card-pd-ul">
                                <li className="card-pd-list exado_body_text_three">
                                    {t("contact_details")}{" "}
                                </li>
                                <li className="card-pd-list exado-title-six">
                                    <PiPhoneLight /> {getPatientViewDetailsData?.result?.phone}
                                </li>
                                <li className="card-pd-list exado-title-six">
                                    <AiOutlineMail /> {getPatientViewDetailsData?.result?.email}
                                </li>
                                <li className="card-pd-list exado_body_text_three">
                                    {t("Additional")} {t("Information")}{" "}
                                </li>
                                <li className="card-pd-list exado-title-six">
                                    {t("Nationality")} : {getPatientViewDetailsData?.result?.country}
                                </li>
                                <li className="card-pd-list exado-title-six">
                                    {t("Language")} :{" "}
                                    {getPatientViewDetailsData?.result?.preferredLanguageIds?.join(
                                        ", "
                                    )}
                                </li>
                            </ul>
                        }
                        className="cardd cardd1"
                    />
                </Col>
                <Col>
                    <Cards.Cardd
                        header={
                            <>
                                <div className="blkIcon">
                                    <PiCalendar className="iicon" />
                                </div>
                                <h5 className="exado-title-seven card-header-text">
                                    {t("appointment")} {t("Information")}
                                </h5>
                            </>
                        }
                        content={
                            <ul className="card-pd-ul">
                                <li className="card-pd-list exado_body_text_three">{t("date")} :</li>
                                <li className="card-pd-list exado-title-six">
                                    {new Date(
                                        getAppointmentsData?.result?.patientAppointments[0]?.appointmentDateTime
                                    )
                                        .toLocaleDateString("en-US", {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric",
                                        })
                                        .replace(",", "th,")}
                                </li>
                                <li className="card-pd-list exado_body_text_three">{t("time")} :</li>
                                <li className="card-pd-list exado-title-six">{new Date(getAppointmentsData?.result?.patientAppointments[0]?.appointmentDateTime).toLocaleTimeString(
                                    "en-US",
                                    {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                    }
                                )}</li>
                                <li className="card-pd-list exado_body_text_three">
                                    {t("booking_id")} :
                                </li>
                                <li className="card-pd-list exado-title-six">{getAppointmentsData?.result?.patientAppointments[0]?.bookingId}</li>
                                <li className="card-pd-list exado_body_text_three">
                                    {t("consultation_fee")} :
                                </li>
                                <li className="card-pd-list exado-title-six"> {
                                    getAppointmentsData?.result?.patientAppointments[0]?.amount + " " +
                                    getAppointmentsData?.result?.patientAppointments[0]?.doctorCurrency}</li>
                            </ul>
                        }
                        className="cardd cardd1"
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <NavAndTabs.NavAndTabs
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={onTabChange}
                    />
                </Col>
            </Row>
        </Container>
    );

    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default PatientDetailsPage;
